import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import LanguageSwitcher from '../../LanguageSwitcher';
import './Auth.scss';

const SignInForm = ({ setParamsLogin, onSubmit }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('auth');
  const { t: tc } = useTranslation('common');

  const handleSubmit = (params) => {
    setParamsLogin && setParamsLogin(params);
    onSubmit && onSubmit(params);
  };

  return (
    <div className={`SignInForm`}>
      <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/SignIn/logo.svg`} alt="logo" />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">{t('loginTitle')}</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label={t('workEmail')}
            name="email"
            rules={[
              { type: 'email', message: tc('invalidEmail') },
              { required: true, message: tc('required') },
            ]}
          >
            <Input size="large" placeholder="name@company.com" />
          </Form.Item>
          <Form.Item label={t('password')} name="password" rules={[{ required: true, message: tc('required') }]}>
            <Input.Password size="large" placeholder={t('password')} />
          </Form.Item>
          <div className="ForgotPassword">
            <Link to="/forgot-password">{t('forgotPassword')}</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            {t('login')}
          </Button>
        </div>
      </Form>
      {/*<div className="Register">
        {t('noAccount')} <Link to="/login">{t('register')}</Link>
      </div>*/}
      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default SignInForm;
